/**
 * Created by fwt on 2018/8/20.
 */
import React,{Component} from 'react';
import "./style.less"
import {NavBar, InputItem, Radio, List, Picker, Toast, Modal,Checkbox } from "antd-mobile";
import cityData from "../../../utils/areaData"
import {invoiceGetName,invoiceApply,invoiceWeChat,getpassengerinfo} from "../../../service/invoiceService"
import HistorInfo from "../../../components/HistorInfo";
import PayModal from "../../../components/PayModal";
import {connect} from "react-redux";
let isSubmit = false;
let areaVal = "";//所在地区
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class InvoiceInfo extends Component{
    constructor(props) {
        super(props);
        if (isSubmit) {
            isSubmit = false;
            props.history.goBack();
        }
        // console.log(this.props);
        this.state = {
            invoiceTit: [
                {value: 0, label: '个人/非企业单位'},
                {value: 1, label: '企业单位'},
            ],
            sendTit:[
                {value: 1, label: '邮寄'},
                {value: 2, label: '自取'},
            ],
            sendTitVal:1,//接收类型
            passengerData:"",
            checkboxData: [
                {value: 1, label: '乘车时间',flag:false},
                {value: 2, label: '身份证号',flag:false},
                {value: 3, label: '出发地目的地',flag:false},
                {value: 4, label: '乘客姓名',flag:false},
            ],
            invoiceType: "dianzi",//发票类型
            invoiceTitVal:0,//抬头类型
            invoiceName:"",//抬头
            invoiceTfe:"",//税号
            addressPhone:'',//地址电话
            bankNo:"",//开户行银行账号
            buyerAddress:"", 
			buyerTelphone:"", 
			buyerBankName:"", 
			buyerBankNumber:"", 
            recipient:"",//收件人
            invoicePhone:"",//联系电话
            areaVal:"",//所在区域
            invoiceAddress:"",//详细地址
            email:"",//电子邮箱
            userPhone:"",//接收人电话
            historyInfoModal:false,
            // protocolVal:false,//同意协议、
            // proposerMobile:"",//申请人电话
            // proposerAddress:"",//申请人地址
            payModal:false,
            payData:"",
            formPay:"",
            passengerList:[
                // {id:1,name:'周杰伦',idnum:'4302********8888',time:'2023-05-06',city:'昆明市-贵州市文山市贵州市文山市贵州市文山市贵州市文山市'},
                // {id:2,name:'周杰伦',idnum:'4302********8888',time:'2023-05-06',city:'昆明市-贵州市文山市'},
                // {id:3,name:'周杰',idnum:'4302********8888',time:'2023-05-06',city:'昆明市-贵州市'},
            ],
            showMore:false,
        }
    }
    componentDidMount() {
        // let checkboxData = this.state.checkboxData;
        // console.log(this.props)
        // if(this.props.location.state.type == 4){
        //     checkboxData.map((res,i)=>{
        //         if(res.value == 2 || res.value == 4){
        //             checkboxData.splice(i,1)
        //         }
        //     })
        // }
        // this.setState({checkboxData})
        let params={
            token:this.props.userInfo.token,
            source:1,
            data:{
                ids:this.props.location.state.invoiceId,
                orderType:this.props.location.state.type,
            },
        };
        invoiceGetName(params).then((res)=>{
            if (res.data.code === '0000') {
                let data = [];
                res.data.data.map((n)=>{
                    data.push({value:n, label:n});
                });
                this.setState({passengerData:data})
            }else{
                Toast.info(res.data.msg,3)
            }
        })
        getpassengerinfo(params).then((res)=>{
            if (res.data.code === '0000') {
                this.setState({passengerList:res.data.data})
            }else{
                Toast.info(res.data.msg,3)
            }
        })

    }
        //如果选择纸质发票，选择所在区域寄快递的地址
    selectOk(v){
        this.setState({areaVal:v})
    }
    inputChange = key =>(e) =>{
        this.setState({ [key]: e })
    };
    invoiceBtn(){
        const {invoiceType,invoiceTitVal,invoiceName,invoiceTfe,addressPhone,bankNo,checkboxData,recipient,invoicePhone,invoiceAddress,email,sendTitVal,userPhone,buyerAddress,buyerTelphone,buyerBankName,buyerBankNumber} = this.state;
        if(invoiceName === ""){
            Toast.info("请填写发票抬头");
            return
        }
        if(invoiceTfe === "" && invoiceTitVal === 1){
            Toast.info("请填写税号");
            return
        }
        if(invoiceTfe === "" && invoiceTitVal === 0){
            Toast.info("请填写身份证号");
            return
        }
        if(invoiceType === 'dianzi' && (email === "" && userPhone === "")){
            Toast.info("请填写电子邮箱或者接收电话");
            return
        }
        if(invoiceType === 'zhizhi' && recipient === ""  && sendTitVal === 1){
            Toast.info("请填写收件人");
            return
        }
        if(invoiceType === 'zhizhi' && invoicePhone === ""  && sendTitVal === 1){
            Toast.info("请填写联系电话");
            return
        }
        if(invoiceType === 'zhizhi' && areaVal === ""  && sendTitVal === 1){
            Toast.info("请选择所在区域");
            return
        }
        if(invoiceType === 'zhizhi' && invoiceAddress === ""  && sendTitVal === 1){
            Toast.info("请填写详细地址");
            return
        }
        // if(this.state.protocolVal === false){
        //     Toast.info("请同意开具发票协议再申请");
        //     return
        // }
        let remark= [];
        checkboxData.map((res)=>{
           if(res.flag){remark.push(res.value)}
        });
        let params = {
            token:this.props.userInfo.token,
            source:1,
            data:{
                orderType:this.props.location.state.type,//城际：1,城内：2,接送站：5，包车：4,带货：7
                ids:this.props.location.state.invoiceId,//订单id
                invoiceType:invoiceType == 'dianzi' ? 0:1,//电子：0，纸质 ：1
                upType:invoiceTitVal,//抬头类型 个人：0，企业：1
                // invoiceUp:this.props.location.state.type == 1 ? invoiceTitVal == 1 ? invoiceName : invoiceName[0] : invoiceName,//发票抬头
                invoiceUp:invoiceName,//发票抬头
                invoiceNumber:invoiceTfe,//发票税号
                // companyPhone:addressPhone,//地址电话
                // bankAccount:bankNo,//开户行账号
                buyerAddress:buyerAddress?buyerAddress:'', 
				buyerTelphone:buyerTelphone?buyerTelphone:'', 
				buyerBankName:buyerBankName?buyerBankName:'', 
				buyerBankNumber:buyerBankNumber?buyerBankNumber:'',
                invoiceContent:'*运输服务*客运服务费',//发票内容
                invoiceAmount:this.props.location.state.invoicePic,//发票金额
                notes:remark,//发票备注
                recipient:recipient,//收件人
                contactPhone:invoicePhone.replace(/\s/ig, ''),//联系电话
                contactAddress:areaVal + invoiceAddress,//收件详细地址
                moneySource:1,
                email:email,
                receiveType:sendTitVal,
                userPhone:userPhone,
                isBwy:this.props.location.state.isBwy,
                invoiceSign:this.props.location.state.invoiceSign, 
            },
            // orderIds:this.props.location.state.invoiceId ? this.props.location.state.invoiceId.join(',') :'',
            // contactMobile:this.state.invoicePhone.replace(/\s/ig, ''),
        };
        Modal.alert('提示',
            (<div className="refundText">请认真核对您的开票信息，一经开出公司不予重开！</div>),
            [{
                text: '取消',
                style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
            }, {
                text: '确认',
                onPress: () => {
                    Toast.loading("",0);
                    invoiceApply(params).then((res)=>{
                        Toast.hide();
                        if(res.data.code === "0000"){
                            if(this.state.invoiceType === 'zhizhi' && this.state.sendTitVal === 1){
                                Toast.hide();
                                // console.log(res.data.data);
                                //如果为纸质发票调用支付
                                this.setState({payModal:true,payData:res.data.data});
                            }else{
                                isSubmit = true;
                                this.props.history.push('/invoiceSucceed');
                            }
                        }else{
                            Toast.info(res.data.msg);
                        }
                    })
                },
                style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
            }]
        )
        // Toast.loading("正在加载");
        // console.log(params.data)
        // return
    }
    payType(e){
        if(e == ""){
            Toast.info("请选择支付方式");
            return
        }
        if(e == "工商银行支付"){
            this.weiXinPay(this.state.payData,"icbcjft");
        }
        if(e== "微信支付"){
            this.weiXinPay(this.state.payData,"wx");
        }
    }
    weiXinPay = (orderNo,type) => {
        const params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                source:1,
                orderId: orderNo,
                payChannel:type,
            }
        };
        invoiceWeChat(params).then((res) => {
            if (res.data.code === '0000') {
                if(type == "wx"){
                    this.wxBridgeReady(res);
                }else{
                    isSubmit = true;
                    // window.location.href = res.data.data.qrcode;
                    this.setState({formPay:res.data.data,});
                }
            }else {
                Toast.info(res.data.msg);
            }
        })
    };
    wxBridgeReady = (resp) =>{
        const self = this;
        function onBridgeReady() {
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId": resp.data.data.appId,         //公众号名称，由商户传入
                    "timeStamp": resp.data.data.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": resp.data.data.nonceStr,   //随机串
                    "package": resp.data.data.package,     //prepay_id
                    "signType": resp.data.data.signType,   //微信签名方式
                    "paySign": resp.data.data.sign         //微信签名
                },
                function(res){
                    if(res.err_msg === "get_brand_wcpay_request:ok") {
                        Toast.success("支付成功",2,()=>{
                            isSubmit = true;
                            self.props.history.push('/invoiceHistory')
                        });
                    }else if(res.err_msg === "get_brand_wcpay_request:cancel") {
                        Toast.info("支付过程中用户取消");
                    }else if(res.err_msg === "get_brand_wcpay_request:fail") {
                        Toast.fail("支付失败");
                    }else {
                        Toast.fail("未知异常");
                    }
                }
            );
        }
        if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
    };


    getArea(labels){
        // areaVal = labels.join(',');//取value代码
        areaVal = '';
        labels.map((res)=>{
            areaVal += res
        });
        return labels.join(',');
    }
    // protocolChange =(e)=>{
    //     this.setState({protocolVal:e.target.checked});
    //     console.log(e.target.checked);
    // };
    addActive(v, key){
        this.setState({[key]: v,});
    };
    checkChange(e,res){
        res.flag = e.target.checked;
    }
    onClose = key => () => {
        this.setState({[key]: false});
    };
    selInfo=(res)=>{
        this.setState({
            historyInfoModal: false,
            invoiceName:res.invoiceUp,
            invoiceTfe:res.invoiceNumber,
            buyerAddress:res.buyerAddress,
            buyerTelphone:res.buyerTelphone,
            buyerBankName:res.buyerBankName,
            buyerBankNumber:res.buyerBankNumber,
        });
    };
    payClose = () => {
        this.setState({payModal:false});
    };
    payFrom(){
        if(this.state.formPay !== ""){
            return(
                <form
                    name="auto_submit_form"
                    method="post"
                    action={this.state.formPay.url}>
                    <input
                        type="hidden"
                        name="biz_content"
                        value={this.state.formPay.bizContent} />
                    <input type="submit" value="立刻提交" style={{display:"none"}} onClick={setTimeout(()=>document.forms[0].submit(),100)}/>
                </form>
            )
        }else{
            return null
        }
    }
    packup(){

    }
    render(){
        const {showMore,passengerList,passengerData,recipient,invoiceType,invoiceTit,invoiceTitVal,invoiceName,invoiceTfe,invoicePhone,invoiceAddress,areaVal,email,sendTit,sendTitVal,userPhone,buyerAddress,buyerTelphone,buyerBankName,buyerBankNumber} = this.state;
        return(
            <div className="invoiceInfo">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >开具发票</NavBar>

                <div className="warp">
                    <div className="con">
                        <div className="tit">请选择发票类型</div>
                        <div className="info">
                            <div className="invoiceType">
                                <span className={invoiceType === "dianzi" ? 'activity dianzi' : 'dianzi'} onClick={()=>this.setState({invoiceType :'dianzi'})}>电子发票<i>3~5天开具</i></span>
                                <span className={invoiceType === "zhizhi" ? 'activity' : ''}  onClick={()=>this.setState({invoiceType :'zhizhi'})}>纸质发票<i>3~5天开具</i></span>
                                <p>使用电子发票与纸质发票具有同等法律效力，可支持报销入账。</p>
                                {/*{invoiceType.map((res, i) => (
                                <Radio className="my-radio" key={i} checked={invoiceVal === res.value}
                                       onChange={() => this.setState({invoiceVal: res.value})}>
                                    {res.label}
                                </Radio>
                            ))}*/}
                            </div>
                            <div className="tit">发票详情</div>
                            <List.Item>
                                抬头类型
                                {invoiceTit.map((res, i) => (
                                    <Radio className="my-radio" key={i} checked={invoiceTitVal === res.value}
                                           onChange={() => this.setState({invoiceTitVal: res.value,invoiceName:"",invoiceTfe:""})}>
                                        {res.label}
                                    </Radio>
                                ))}
                            </List.Item>
                            {/*<div className="historInfo" onClick={()=>this.props.history.push(`/historInfo`)}>选择填入历史信息</div>*/}
                            {
                                this.state.invoiceTitVal === 1 ? (
                                    <div className="historInfo" onClick={()=>this.setState({historyInfoModal:true})}>选择填入历史信息</div>
                                ):null
                            }
                            {
                                 <InputItem
                                 className="inp"
                                 placeholder="填写发票抬头"
                                 value={invoiceName}
                                 onChange={this.inputChange("invoiceName")}
                             ><span style={{color:'red'}}>*</span>发票抬头</InputItem>
                                // 取消选择发票抬头，改为全部输入框
                                // this.props.location.state.type == 1 ?
                                //     (this.state.invoiceTitVal === 1 ? (
                                //         <InputItem
                                //             className="inp"
                                //             placeholder="填写发票抬头"
                                //             value={invoiceName}
                                //             onChange={this.inputChange("invoiceName")}
                                //         ><span style={{color:'red'}}>*</span>发票抬头</InputItem>
                                //     ):<Picker
                                //         cols={1}
                                //         data={passengerData}
                                //         value={invoiceName}
                                //         onOk={(v) =>this.addActive(v, 'invoiceName')}
                                //     >
                                //         <List.Item arrow="horizontal" className="selPas"><span style={{color:'red'}}>*</span>发票抬头</List.Item>
                                //     </Picker>):(
                                //     <InputItem
                                //         className="inp"
                                //         placeholder="填写发票抬头"
                                //         value={invoiceName}
                                //         onChange={this.inputChange("invoiceName")}
                                //     ><span style={{color:'red'}}>*</span>发票抬头</InputItem>)
                            }
                            {
                                this.state.invoiceTitVal === 1 ?
                                    <InputItem
                                        className="inp"
                                        placeholder="填写纳税人识别号"
                                        value={invoiceTfe}
                                        onChange={this.inputChange("invoiceTfe")}
                                    ><span style={{color:'red'}}>*</span>税号</InputItem> :
                                    <InputItem
                                        className="inp"
                                        placeholder="填写身份证号"
                                        value={invoiceTfe}
                                        onChange={this.inputChange("invoiceTfe")}
                                    ><span style={{color:'red'}}>*</span>身份证号</InputItem>
                            }
                            {
                                this.state.invoiceTitVal === 1&&
                                <InputItem
                                className="inp"
                                placeholder="填写公司地址"
                                value={buyerAddress}
                                onChange={this.inputChange("buyerAddress")}
                            >公司地址</InputItem>}
                           { 
                           this.state.invoiceTitVal === 1&&
                           <InputItem
                                className="inp"
                                placeholder="填写公司电话"
                                value={buyerTelphone}
                                onChange={this.inputChange("buyerTelphone")}
                            >公司电话</InputItem>}
                           { 
                             this.state.invoiceTitVal === 1&&
                                <InputItem
                                    className="inp"
                                    placeholder="开户行"
                                    value={buyerBankName}
                                    onChange={this.inputChange("buyerBankName")}
                                >开户行</InputItem>}
                            { 
                                this.state.invoiceTitVal === 1&&
                                <InputItem
                                    className="inp"
                                    placeholder="填写卡号"
                                    value={buyerBankNumber}
                                    onChange={this.inputChange("buyerBankNumber")}
                                >卡号</InputItem>}

                            <List.Item  extra={"*运输服务*客运服务费"}>发票内容</List.Item>
                            {/*<List.Item className="invociePic" extra={"￥"+this.props.location.state.invoicePic}>发票金额</List.Item>*/}
                            <List.Item className="invociePic" extra={'￥' + this.props.location.state.invoicePic}>发票金额</List.Item>


                            {/* 注释备注信息选择改为乘客信息 */}
                            {/* {
                                (this.props.location.state.type == 1 ||  this.props.location.state.type == 4) && this.props.location.state.invoiceType == 0 ?
                                    <List.Item>
                                        <span>备注信息：</span>
                                        <div className="checkbox">
                                            {this.state.checkboxData.map((res, i) => (
                                                <Checkbox className="my-checkbox" key={i}
                                                          onChange={(e) => this.checkChange(e,res)}
                                                >
                                                    &nbsp;{res.label}
                                                </Checkbox>
                                            ))}
                                        </div>
                                    </List.Item> : null
                            } */}
                        </div>
                    </div>
                        <div className="con">
                            <div className="tit">乘客信息<div className='red red1'>*如需修改出行人员信息的可联系客服，修改完成后再行申请</div></div>
                            {passengerList.length > 0 ?
                            <div className={showMore ? "passengertextbox" :"passengertextbox passengertextboxHidden"} >
                                {passengerList.map((res)=>(
                                    <div className='passengertext'>
                                        <i className="icon iconfont iconpeople"/>
                                        <span className=''>{res.carriageName}</span>
                                        <span className=''>{res.carriageIdNo.substr(0, 4)+ '*******' +res.carriageIdNo.substr(14)}</span>
                                        <span className=''>{res.carriageDateYmd}</span>
                                        <span className=''>{res.carriageLeave+'-'+res.carriageArrive}</span>
                                    </div>
                                ))}
                            </div>:null}
                            {
                                passengerList.length > 2 ? <div className='more'>
                                {showMore?
                                <i className="icon iconfont iconzhankai1" onClick={()=>{this.setState({showMore:false})}}/>:
                                <i className="icon iconfont iconshouqi" onClick={()=>{this.setState({showMore:true})}}/>}
                            </div>:null
                            }
                        </div>
                    {
                        invoiceType === 'dianzi' ? (
                            <div className="con">
                                <div className="tit">接收方式</div>
                                <div className="info">
                                    <InputItem
                                        className="inp"
                                        placeholder="请填写电子邮箱"
                                        value={email}
                                        onChange={this.inputChange("email")}
                                    >电子邮箱</InputItem>
                                    <InputItem
                                        className="inp"
                                        placeholder="请填写接收电话"
                                        value={userPhone}
                                        onChange={this.inputChange("userPhone")}
                                    >接收电话</InputItem>
                                </div>
                            </div>
                        ) : (
                            <div className="con ">
                                <div className="tit">接收方式</div>
                                <div className="info">
                                    <List.Item>
                                        接收类型
                                        {sendTit.map((res, i) => (
                                            <Radio className="my-radio" key={i} checked={sendTitVal === res.value}
                                                   onChange={() => this.setState({sendTitVal: res.value,})}>
                                                {res.label}
                                            </Radio>
                                        ))}
                                    </List.Item>
                                </div>

                                {
                                    sendTitVal == 1 ? (
                                        <div className="info">
                                            <InputItem
                                                className="inp"
                                                placeholder="请填写收件人"
                                                value={recipient}
                                                onChange={this.inputChange("recipient")}
                                            >收件人</InputItem>
                                            <InputItem
                                                type="phone"
                                                className="inp"
                                                placeholder="请填写联系电话"
                                                value={invoicePhone}
                                                onChange={this.inputChange("invoicePhone")}
                                            >联系电话</InputItem>
                                            <Picker
                                                title="选择地区"
                                                extra="请选择所在区域"
                                                data={cityData}
                                                value={areaVal}
                                                // onChange={(v) => this.setState({areaVal:v})}
                                                format={(labels) => this.getArea(labels)}
                                                onOk={v => this.selectOk(v)}
                                            >
                                                <List.Item arrow="horizontal" >所在区域</List.Item>
                                            </Picker>
                                            <InputItem
                                                className="inp address"
                                                placeholder="请填写详细地址"
                                                value={invoiceAddress}
                                                onChange={this.inputChange("invoiceAddress")}
                                            >详细地址</InputItem>
                                            <div className="text">* 纸质发票申请将收取发票邮寄费用10元/次</div>
                                        </div>
                                    ):null
                                }

                            </div>
                        )
                    }
                    {/*<div className="protocol">
                        <CheckboxItem  onChange={(e) => this.protocolChange(e)}>
                            <div onClick={() => this.props.history.push('/invoiceProtocol')}>我同意开具发票协议</div>
                        </CheckboxItem>
                    </div>*/}
                    <button onClick={()=>this.invoiceBtn()}>提交</button>
                </div>
                <HistorInfo
                    onClose={this.onClose.bind(this)}
                    selInfo={this.selInfo.bind(this)}
                    historyInfoModal={this.state.historyInfoModal}
                />
                <PayModal
                    modal={this.state.payModal}
                    onClose={this.payClose.bind(this)}
                    payType={this.payType.bind(this)}
                />
                {this.payFrom()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/InvoiceInfo/index.js